<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
  
    <div class="main-content" style="padding: 15px; margin: 5px; width: -webkit-fill-available;">
      <div class="rights-wise-login">
        <div class="main-heading">
          <h1>Company Master</h1>
        </div>
        <div class="container-fluid rights-login-wise">
          <form [formGroup]="companyForm" (ngSubmit)="onSubmit()">
            <div class="form-row">
              <div class="form-group">
                <label>Company Name:</label>
                <input type="text" formControlName="company_name" autocomplete="off" required />
                <div *ngIf="isFieldInvalid('company_name')" class="error-message">
                  Company Name is required.
                </div>
              </div>
  
              <div class="form-group">
                <label>Start Date:</label>
                <p-calendar formControlName="start_date" dateFormat="dd-mm-yy" [showIcon]="true" placeholder="Select Date"
                appendTo="body"></p-calendar>
                <div *ngIf="isFieldInvalid('start_date')" class="error-message">
                  Start Date is required.
                </div>
              </div>
  
              <div class="form-group">
                <label>Expiry Date:</label>
                <p-calendar formControlName="expiry_date" dateFormat="dd-mm-yy" [showIcon]="true" placeholder="Select Date"
                appendTo="body"></p-calendar>
                <div *ngIf="isFieldInvalid('expiry_date')" class="error-message">
                  Expiry Date is required.
                </div>
                <div *ngIf="companyForm.errors?.expiryBeforeStart" class="error-message">
                    Expiry date must be greater than or equal to the start date.
                  </div>
              </div>
            </div>
  
            <div class="form-row" style="margin-top: 10px;">
              <label>Status:</label>
              <div class="form-group row">
                <label>
                  <input type="radio" formControlName="status" value="Active" style="width: 20px; height: 20px; margin-left: 20px;"/>
                  Active
                </label>
                <label style="margin-left: 20px;">
                  <input type="radio" formControlName="status" value="Inactive" style="width: 20px; height: 20px;"/>
                  Inactive
                </label>
                <div *ngIf="isFieldInvalid('status')" class="error-message">
                  Status is required.
                </div>
              </div>
            </div>
  
            <div class="form-row submit-buttons" style="margin-top: 15px;">
              <button type="submit" class="btn btn-primary" [disabled]="companyForm.invalid">
                Submit
              </button>
            </div>
          </form>
        </div>
        <div style="margin-top: 50px;">
          <div class="main-heading">
              <h1>Registered Company</h1>
          </div>
          <div class="card">
              <p-table #dt [value]="userData" [tableStyle]="{'min-width': '60rem'}" [paginator]="true" [rows]="10"
                  [showCurrentPageReport]="true" [globalFilterFields]="['email']"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                  [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading">
                  <ng-template pTemplate="caption">
                      <div class="flex" style="display: flex; justify-content: flex-end; gap: 10px;">
                          <span class="p-input-icon-left ml-auto">
                            <input pInputText type="text"
                            (input)="dt.filter($event.target.value, 'company_name', 'contains')"
                            placeholder="Search by Company" />
                          </span>
                      </div>
                  </ng-template>
                  <ng-template pTemplate="header">
                      <tr>
                          <th pSortableColumn="company_name">
                              <span class="header-container">
                                Company Name
                                  <p-sortIcon field="company_name"></p-sortIcon>
                              </span>
                          </th>
                          <th pSortableColumn="start_date">
                              <span class="header-container">
                                  Start Date
                                  <p-sortIcon field="start_date"></p-sortIcon>
                              </span>
                          </th>
                          <th pSortableColumn="expiry_date">
                              <span class="header-container">
                                  Expiry Date
                                  <p-sortIcon field="expiry_date"></p-sortIcon>
                              </span>
                          </th>
                          <th pSortableColumn="status">
                              <span class="header-container">
                                  Status
                                  <p-sortIcon field="status"></p-sortIcon>
                              </span>
                          </th>   
                          <th>Actions</th>
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                      <tr>
                          <td>{{ rowData['company_name'] }}</td>
                          <td>{{ rowData['start_date'] }}</td>
                          <td>
                            <ng-container *ngIf="rowData.isEditing">
                                <p-calendar [(ngModel)]="rowData.expiry_date" dateFormat="dd-mm-yy"
                                    [showIcon]="true" placeholder="Select Date"
                                    appendTo="body" (ngModelChange)="onDateChange($event, rowData, rowIndex)">
                                </p-calendar>
                                <div *ngIf="rowData.dateError" class="text-danger">
                                    {{ rowData.dateError }}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!rowData.isEditing">
                                {{ rowData['expiry_date'] }}
                            </ng-container>
                        </td>
                          <td>
                            <ng-container *ngIf="rowData['status'] == 'Active'">
                              <button class="btn btn-primary"
                                  (click)="changeUserStatus(rowData, false)">Active</button>
                            </ng-container>
                            <ng-container *ngIf="rowData['status'] == 'Deactive'">
                                <button class="btn btn-secondary"
                                    (click)="changeUserStatus(rowData, true)">Deactive</button>
                            </ng-container>
                          </td>
                         
                          <td>
                              <button class="btn btn-warning" *ngIf="!rowData.isEditing"
                                  (click)="editRow(rowData)">Edit</button>
                              <button class="btn btn-success" style="margin-right: 4px;" *ngIf="rowData.isEditing"
                                  (click)="saveRow(rowData)">Save</button>
                              <button class="btn btn-danger" *ngIf="rowData.isEditing"
                                  (click)="cancelEdit(rowData)">Cancel</button>
                          </td>
                      </tr>
                  </ng-template>
              </p-table>
          </div>
      </div>
      </div>
    </div>
  </div>
  